import { render, staticRenderFns } from "./ReviewStatementBooksComponent.vue?vue&type=template&id=53ecf5af&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./ReviewStatementBooksComponent.vue?vue&type=script&lang=js&"
export * from "./ReviewStatementBooksComponent.vue?vue&type=script&lang=js&"
import style0 from "./ReviewStatementBooksComponent.vue?vue&type=style&index=0&id=53ecf5af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ecf5af",
  null
  
)

component.options.__file = "ReviewStatementBooksComponent.vue"
export default component.exports